module.exports = __webpack_public_path__ + "static/media/rp_entry_banner.6561d9f4.svg";